import * as d3 from 'd3'

import {
    bottomZone,
    depthMidPlateFt,
    plateWidthFt,
    topZone,
} from 'bam-node-baseball-savant/constants/zone.ts'
import { EVPData, StrikeZone } from '../../../schema/types.ts'
import canBePersonalized from './can-be-personalized.ts'

const genericZone = {
    top: topZone,
    bot: bottomZone,
    width: plateWidthFt,
    depth: depthMidPlateFt,
}
function getPersonalZone(data: EVPData[]) {
    const { szBot, szTop, szWidth, szDepth } = data[0]

    if (!canBePersonalized(data)) {
        console.error("Personal Zone can't be Personalized")
    }

    return {
        top: szTop || topZone,
        bot: szBot || bottomZone,
        width: szWidth || plateWidthFt,
        depth: szDepth || depthMidPlateFt,
    }
}

function getAverageZone(data: EVPData[]) {
    const szTop = d3.mean(data, (d) => d.szTop)
    const szBot = d3.mean(data, (d) => d.szBot)

    const szWidth = d3.mean(data, (d) => d.szWidth)
    // Yikes
    const szDepth = d3.mean(data, (d) => d.szDepth)

    if (!data.length || !szTop || !szBot || !szWidth || !szDepth) {
        return genericZone
    }

    return {
        top: szTop,
        bot: szBot,
        width: szWidth,
        depth: szDepth,
    }
}

export type StrikeZoneDim = {
    top: number
    bot: number
    width: number
    depth: number
}

export default function getStrikeZoneDims(
    strikeZone: StrikeZone,
    data: EVPData[]
): StrikeZoneDim {
    switch (strikeZone) {
        case 'personal':
            return getPersonalZone(data)
        case 'average':
            return getAverageZone(data)
        // case 'generic-old':
        //     return {
        //         top: topZoneOld,
        //         bot: bottomZoneOld,
        //         width: plateWidthFt,
        //         depth: depthOld,
        //     }
        case 'generic':
        default:
            return genericZone
    }
}
